module.exports = __webpack_public_path__ + "img/Frente-15-02 open.ef224ed1.jpg";